import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '../../../../../../../../../../core/animations';
import * as _ from 'lodash';

// Local component
import { ToastComponent } from '../../../../../../../common/toast.component';

// Model & Util
import { CreateSolutionDescription, SolutionDescriptionInitialDM } from '../../../../../../../models/index';
import { checkoutFields, toastMsg, displayValues } from '../../../../../../../utils/index';

//Services
import { SideNavService } from '../../../../sidenav.service';
import { AuditHistoryService } from '../../../../../../../../../../core/services/audit-history.service';


@Component({
  selector: 'spekwo-create-solution-description',
  templateUrl: './create-solution-description.component.html',
  styleUrls: ['./create-solution-description.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})

export class SpekwoSolutionDescriptionComponent implements OnInit {

  checkoutFields = checkoutFields;
  toastMsg = toastMsg;
  displayValues = displayValues;
  solutionFields: SolutionDescriptionInitialDM;
  isSolutionUpload: boolean = false;
  subCategoryList: any;
  primaryCategoryList: any;
  subCategoriesList: any;

  @Input() screenType: any;

  constructor(
    private _sideNavService: SideNavService,
    private _toastComponent: ToastComponent,
    public auditHistoryService: AuditHistoryService,
  ) { }

  ngOnInit() {

  }


  onSubmitFile(submitedValues) {//handle with one parameter

    let CategoryId = submitedValues.categoryid;

    this.primaryCategoryList = submitedValues.primaryCategory;
    this.subCategoriesList = submitedValues.subCategory;

    this.solutionFields = submitedValues.SolutionDescriptionInitialDM;
    this.solutionFields.keyword = [];
    //Pushing keywords fields to keyword array
    this.solutionFields.keyword.push(submitedValues.key1);
    this.solutionFields.keyword.push(submitedValues.key2);
    this.solutionFields.keyword.push(submitedValues.key3);
    this.solutionFields.keyword.push(submitedValues.key4);

    console.log("created form", submitedValues.keyword);

    this.isSolutionUpload = true;

    // Store in db
    console.log("thisSolutionFields", this.solutionFields)
    this._sideNavService.CreateSolutionDescriptionOnDb(this.solutionFields)
      .then(async (createRes: CreateSolutionDescription) => {
        this.auditHistoryFunCall(displayValues.success)

        this.isSolutionUpload = false;
        this._toastComponent.showToast(this.toastMsg.uploadSolutionDescriptionSuccess);
      }).catch((err) => {
        this.isSolutionUpload = false;
        this._toastComponent.showToast(this.toastMsg.uploadCompanyLogoFailed);
        this.auditHistoryFunCall(displayValues.failed)
      });

    //store primaru category in DB

    //flag handling 
    let check = _.filter(this.primaryCategoryList, data => {
      if (this.solutionFields.keyPrimCategory.toUpperCase().trim() === data.category.trim()) {
        return data.category;
      }
    }
    );

    console.log("check", check);
    if (check && check.length > 0) {
      console.log("primary category already present");
    }
    else {
      console.log("primary category not present");
      this._sideNavService.createPrimaryCategory(this.solutionFields.keyPrimCategory).then((response: any) => {

        this.solutionFields.categoryid = response.data.createWccategory.wccategoryEdge.node.categoryid;

        this.createSubCategory(this.solutionFields.categoryid, this.solutionFields.subcategory);
      }).catch((err) => {
        console.log(err);
      })
    }
    if (check && check.length > 0 && check[0].categoryid) {
      this.createSubCategory(check[0].categoryid, this.solutionFields.subcategory);
    }
  }

  createSubCategory(categoryId, subCategoryValue) {

    //store sub category in DB

    // handle with flag 
    let checkSub = _.filter(this.subCategoriesList, data => {
      if (subCategoryValue.toUpperCase().trim() === data.subcategory.toUpperCase().trim()) {
        return data.subcategory;
      }
    }
    );
    if (checkSub && checkSub.length > 0) {
      console.log("sub category already present");
    }
    else {
      console.log("sub category not present");
      if (categoryId) {
        this._sideNavService.createSubCategory(categoryId, subCategoryValue).then((response: any) => {
        }).catch((err) => {
          console.log(err);
        })
      }
    }
  }


  auditHistoryFunCall(status) {
    let oldparams = {
      "solution": null,
      "keyPrimCategory": null,
      "subcategory": null,
      "key1": null,
      "key2": null,
      "key3": null,
      "key4": null,
      "costOption": null,
      "totalCost": null,
    };

    let newParams = {
      "solution": this.solutionFields.solution,
      "keyPrimCategory": this.solutionFields.keyPrimCategory,
      "subcategory": this.solutionFields.subcategory,
      "key1": this.solutionFields.key1,
      "key2": this.solutionFields.key2,
      "costOption": this.solutionFields.costOption,
      "totalCost": this.solutionFields.totalCost,
    };

    if(this.solutionFields.key3 && (this.solutionFields.key3 != null || this.solutionFields.key3 != "")){
      newParams['key3'] = this.solutionFields.key3
    }
    if(this.solutionFields.key3 && (this.solutionFields.key4 != null || this.solutionFields.key4 != "")){
      newParams['key4'] = this.solutionFields.key4
    }

    let auditLogPayload = {
      roleId: window.localStorage.getItem('roleId'),
      userId: window.localStorage.getItem('userUID'),
      orderId: null,
      newData: newParams,
      oldData: oldparams,
      auditType: "create_se_into_db",
      logsDesc: "Solution was added to the database ",
      platform: "Executive Dashboard",
      status: status,
      createdAt: "now()"
    };
    this.auditHistoryService.auditHistoryCall(auditLogPayload);
  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/create-solution-description/create-solution-description.component.ts